import { forwardRef } from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const BaseContainer = styled(
  forwardRef((props, ref) => <BaseGrid container ref={ref} {...props} />)
)`
  gap: ${props => props.gap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const BaseItem = styled(forwardRef((props, ref) => <BaseGrid ref={ref} {...props} />))`
  gap: ${props => props.gap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const BaseLayout = styled(props => <BaseContainer {...props} />)`
  height: 100%;
  margin: 0 auto;
  max-width: 100%;
  padding-block: 32px;
  padding-inline: 16px;
  width: 100%;

  ${props => props.theme.breakpoints.up('sm')} {
    max-width: 540px;
  }

  ${props => props.theme.breakpoints.up('md')} {
    max-width: 720px;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    max-width: 960px;
  }

  ${props => props.theme.breakpoints.up('xl')} {
    max-width: 1140px;
  }
`
